import httpClient from '@/lib/httpClient.js'
import useAuthStore from '@/store/useAuthStore.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

export default function useLogout() {
  const authenticate = useAuthStore((state) => state.authenticate)
  const setUserData = useAuthStore((state) => state.setUserData)
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const action = async () => {
    const response = await httpClient.post('auth/logout')

    authenticate(false)
    setUserData(null)
    navigate('/login')

    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: () => {
      queryClient.removeQueries()
    },
  })

  return {
    logout: mutation.mutateAsync,
    logoutStatus: mutation,
  }
  //   return useQuery({ queryKey: ['login'], queryFn: action })
}
